// Pestañas del módulo de Finanzas. Reemplazan a las dos páginas que había
// (Finanzas y Contabilidad), donde los accesos eran botones que desplegaban
// listas de otros botones. Cada pestaña agrupa las vistas por la tarea que
// resuelven; las vistas de destino y sus rutas no cambian.
//
// La pestaña viaja en ?section= y no como segmento de la ruta porque
// /dashboard/finance/:id ya usa esa posición para el condominio. Como el
// resto de las rutas, el parámetro y sus valores van en inglés.
export const SECTIONS = [
  { id: "summary", label: "Resumen" },
  { id: "collections", label: "Cobros" },
  { id: "expenses", label: "Gastos" },
  { id: "settlement", label: "Liquidación" },
  // El plan de cuentas y los libros solo existen para el manager.
  { id: "accounting", label: "Contabilidad", managerOnly: true },
];

export const DEFAULT_SECTION = SECTIONS[0].id;

export const FINANCE_HUB_PATH = "/dashboard/finance";

export const sectionsFor = (role) =>
  SECTIONS.filter((section) => !section.managerOnly || role === "manager");

export const sectionSearch = (id) =>
  id === DEFAULT_SECTION ? "" : `?section=${id}`;

export const sectionHref = (id) => `${FINANCE_HUB_PATH}${sectionSearch(id)}`;

// Una sección desconocida o que el rol no puede ver cae en el resumen.
export const resolveSection = (search, role) => {
  const requested = new URLSearchParams(search).get("section");
  return sectionsFor(role).some((section) => section.id === requested)
    ? requested
    : DEFAULT_SECTION;
};
